import { ResponseDTO } from "../../interfaces/response"
import { HomeServices } from "../services/HomeServices"

interface IHomeService {
  getDashboardByBusiness(idBusiness: number, typeOperation: string): Promise<ResponseDTO>;
  getTransactionByBusiness(idBusiness: number, period: string, pages: number, take: number, typeOperation: string): Promise<ResponseDTO>;
  getTransactionRetriveCmsById(idTXTrsnaction: string): Promise<ResponseDTO | any>;
  mapDashboard(dataTotal: {
    totalamountday: number,
    totalamountmonth: number,
    totaluseractiveday: number,
    totaluseractivemonth: number
  }): Promise<any>;
}

export class HomeController implements IHomeService{
    private homeServices = new HomeServices()

    public async getDashboardByBusiness(idBusiness: number, typeOperation: string): Promise<ResponseDTO> {
        const response: ResponseDTO = (typeOperation === 'OUT')
            ? await this.homeServices.getDashboardOUTByBusiness(idBusiness)
            : await this.homeServices.getDashboardINByBusiness(idBusiness)
        return response
    }

    public async getTransactionByBusiness(idBusiness: number, period: string, pages: number, take: number, typeOperation: string): Promise<ResponseDTO> {
        const response: ResponseDTO = (typeOperation === 'OUT')
            ? await this.homeServices.getTransactionOUTByBusiness(idBusiness, period, pages, take)
            : await this.homeServices.getTransactionINByBusiness(idBusiness, period, pages, take)
        return response
    }

    public async getTransactionRetriveCmsById(idTXTrsnaction: string): Promise<ResponseDTO | any> {
        const response: ResponseDTO | any = await this.homeServices.getTransactionRetriveCmsById(idTXTrsnaction)
        return response
    }

    public async mapDashboard(dataTotal:
        {
            totalamountday: number,
            totalamountmonth: number,
            totaluseractiveday: number,
            totaluseractivemonth: number
        }
    ): Promise<any> {
        const dataMap: any = [
            {
                title: 'Total Volume',
                amount: `$${dataTotal.totalamountday || 0}`,
                totalPercent: `${(dataTotal.totalamountday / 100).toFixed(2) || 0}%`,
                nameUser: 'N/A'
            },
            {
                title: 'Monthly Volume',
                amount: `$${dataTotal.totalamountmonth || 0}`,
                totalPercent: `${(dataTotal.totalamountmonth / 100).toFixed(2) || 0}%`,
                nameUser: 'N/A'
            },
            {
                title: 'Active customers today',
                amount: `$${dataTotal.totaluseractiveday || 0}`,
                totalPercent: `${(dataTotal.totaluseractiveday / 100).toFixed(2) || 0}%`,
                nameUser: 'N/A'
            },
            {
                title: 'Active customers this month',
                amount: `$${dataTotal.totaluseractivemonth || 0}`,
                totalPercent: `${(dataTotal.totaluseractivemonth / 100).toFixed(2) || 0}%`,
                nameUser: 'N/A'
            }
        ]
        return dataMap
    }
}